import { Radio } from '@material-ui/core';
import { CardX } from 'framework/components/cards/CardX';
import { useStateBoolean } from 'framework/hooks/useStateBool';
import { IExactOnlineCostCenter } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';

export function filterCostCenters(ccs: IExactOnlineCostCenter[], search: string | undefined) {
	if (search === undefined) {
		return ccs;
	} else {
		return ccs.filter(t => `${t.code ?? ''} ${t.description ?? ''}`.toLowerCase().includes(search.toLowerCase()));
	}
}

const MajorFontSize = 16;
const MinorFontSize = 13;

type ExactOnlineCostCenterCardXProps = {
	item: IExactOnlineCostCenter;
	onSelect: VoidFunction;
	isSelected: boolean;
	style?: React.CSSProperties;
};

export const ExactOnlineCostCenterCardX = ({ item, style, onSelect, isSelected }: ExactOnlineCostCenterCardXProps) => {
	const strings = useLocalization();
	const [hovered, enter, leave] = useStateBoolean(false);

	return (
		<CardX
			className='df-row gap-8 w100'
			raised={hovered || isSelected}
			onMouseEnter={enter}
			onMouseLeave={leave}
			style={{
				cursor: 'pointer',
				...style,
			}}
			onClick={onSelect}>
			<div className='df-col'>
				<Radio
					style={{ padding: 0 }}
					checked={isSelected}
				/>
			</div>
			<div className='df-col fg1'>
				<span style={{ fontSize: MajorFontSize, fontWeight: 500 }}>{item.description}</span>
				<span style={{ fontSize: MinorFontSize }}>{`${strings.code}: ${item.code}`}</span>
			</div>
		</CardX>
	);
};
